import { buildAxiosAuthenticationHeaders } from "@src/cloud-connect/api/util/build-axios-authentication-headers";
import { ragUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios from "axios";

export const useSendFeedback = (namespace: string | null) => {
  const sendFeedback = async (messageId: string, useful: boolean) => {
    try {
      if (!namespace) {
        return null;
      }
      const url = `${ragUrlEnvVar()}/api/v1/ns/${namespace}/messages/${messageId}/useful`;
      const response = await axios.post(
        url,
        { useful },
        { headers: buildAxiosAuthenticationHeaders() },
      );

      return response;
    } catch (error) {
      console.error(
        `Error sending ${useful ? "positive" : "negative"} feedback:`,
        error,
      );
      return null;
    }
  };

  return {
    sendPositiveFeedback: (messageId: string) => sendFeedback(messageId, true),
    sendNegativeFeedback: (messageId: string) => sendFeedback(messageId, false),
  };
};
